var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Modifier from 'ember-modifier';
import { assert } from '@ember/debug';
import { action } from '@ember/object';
import { isDestroyed, registerDestructor } from '@ember/destroyable';
import hasMoved from '../utils/has-moved';
let DropdownTriggerModifier = (_class = class DropdownTriggerModifier extends Modifier {
  constructor(owner, args) {
    super(owner, args);
    _defineProperty(this, "didSetup", false);
    _defineProperty(this, "triggerElement", void 0);
    _defineProperty(this, "toggleIsBeingHandledByTouchEvents", false);
    _defineProperty(this, "touchMoveEvent", void 0);
    _defineProperty(this, "dropdown", void 0);
    _defineProperty(this, "desiredEventType", void 0);
    _defineProperty(this, "stopPropagation", void 0);
    registerDestructor(this, cleanup);
  }
  modify(element, positional, named) {
    assert('must be provided dropdown object', named.dropdown);
    this.dropdown = named.dropdown;
    this.desiredEventType = named.eventType ?? 'click';
    this.stopPropagation = named.stopPropagation;
    if (!this.didSetup) {
      this.setup(element);
      this.didSetup = true;
    }
    this.update(element, positional, named);
  }
  setup(element) {
    // Keep a reference to the element for cleanup
    this.triggerElement = element;
    if (!element.getAttribute('role')) element.setAttribute('role', 'button');
    element.addEventListener('click', this.handleMouseEvent);
    element.addEventListener('mousedown', this.handleMouseEvent);
    element.addEventListener('keydown', this.handleKeyDown);
    element.addEventListener('touchstart', this.handleTouchStart);
    element.addEventListener('touchend', this.handleTouchEnd);
  }
  update(element, _positional, named) {
    const {
      dropdown
    } = named;
    element.setAttribute('data-ebd-id', `${dropdown.uniqueId}-trigger`);
    element.setAttribute('aria-owns', `ember-basic-dropdown-content-${dropdown.uniqueId}`);
    element.setAttribute('aria-controls', `ember-basic-dropdown-content-${dropdown.uniqueId}`);
    element.setAttribute('aria-expanded', dropdown.isOpen ? 'true' : 'false');
    element.setAttribute('aria-disabled', dropdown.disabled ? 'true' : 'false');
  }
  handleMouseEvent(e) {
    if (typeof document === 'undefined') return;
    const {
      dropdown,
      desiredEventType,
      stopPropagation
    } = this;
    if (isDestroyed(this) || !dropdown || dropdown.disabled) return;
    const eventType = e.type;
    const notLeftClick = e.button !== 0;
    if (eventType !== desiredEventType || notLeftClick) return;
    if (stopPropagation) e.stopPropagation();
    if (this.toggleIsBeingHandledByTouchEvents) {
      // Some devises have both touchscreen & mouse, and they are not mutually exclusive
      // In those cases the touchdown handler is fired first, and it sets a flag to
      // short-circuit the mouseup so the component is not opened and immediately closed.
      this.toggleIsBeingHandledByTouchEvents = false;
      return;
    }
    dropdown.actions.toggle(e);
  }
  handleKeyDown(e) {
    const {
      disabled,
      actions
    } = this.dropdown;
    if (disabled) return;
    if (e.keyCode === 13) {
      // Enter
      actions.toggle(e);
    } else if (e.keyCode === 32) {
      // Space
      e.preventDefault(); // prevents the space to trigger a scroll page-next
      actions.toggle(e);
    } else if (e.keyCode === 27) {
      actions.close(e);
    }
  }
  handleTouchStart() {
    document.addEventListener('touchmove', this._touchMoveHandler);
  }
  handleTouchEnd(e) {
    this.toggleIsBeingHandledByTouchEvents = true;
    const {
      disabled,
      actions
    } = this.dropdown;
    if (e && e.defaultPrevented || disabled) {
      return;
    }
    if (!hasMoved(e, this.touchMoveEvent)) {
      actions.toggle(e);
    }
    this.touchMoveEvent = undefined;
    document.removeEventListener('touchmove', this._touchMoveHandler);
    // This next three lines are stolen from hammertime. This prevents the default
    // behaviour of the touchend, but synthetically trigger a focus and a (delayed) click
    // to simulate natural behaviour.
    const target = e.target;
    if (target !== null) {
      target.focus();
    }
    setTimeout(function () {
      if (!e.target) {
        return;
      }
      try {
        const event = document.createEvent('MouseEvents');
        event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        e.target.dispatchEvent(event);
      } catch (e) {
        const event = new Event('click');
        e.target.dispatchEvent(event);
      }
    }, 0);
    e.preventDefault();
  }
  _touchMoveHandler(e) {
    this.touchMoveEvent = e;
    document.removeEventListener('touchmove', this._touchMoveHandler);
  }
}, _applyDecoratedDescriptor(_class.prototype, "handleMouseEvent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMouseEvent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeyDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleTouchStart", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleTouchStart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleTouchEnd", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleTouchEnd"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_touchMoveHandler", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_touchMoveHandler"), _class.prototype), _class);
export { DropdownTriggerModifier as default };
function cleanup(instance) {
  const {
    triggerElement
  } = instance;
  if (triggerElement) {
    if (typeof document !== 'undefined') document.removeEventListener('touchmove', instance._touchMoveHandler);
    triggerElement.removeEventListener('click', instance.handleMouseEvent);
    triggerElement.removeEventListener('mousedown', instance.handleMouseEvent);
    triggerElement.removeEventListener('keydown', instance.handleKeyDown);
    triggerElement.removeEventListener('touchstart', instance.handleTouchStart);
    triggerElement.removeEventListener('touchend', instance.handleTouchEnd);
  }
}